module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main-container-hot"
    }
  }, [_c('HeaderHotSite'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "landing-intro-container"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./logo_pamcard_branco 1.svg"),
      "alt": "logo"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "link-to",
    on: {
      "click": _vm.scrollToFooter
    }
  }, [_vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', [_vm._v("\n          Quero a minha\n          "), _c('img', {
    attrs: {
      "src": require("./setaBotao.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "pamMessage"
  }, [_vm._v("\n        TAG do caminhoneiro. Uma iniciativa do "), _c('span', [_vm._v("Pamcard")]), _vm._v(" e da "), _c('span', [_vm._v("Move Mais")]), _vm._v(" para viabilizar o único plano de TAG sem taxa de adesão, sem mensalidade, sem vínculo de cartão de crédito.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pamMessage"
  }, [_vm._v("Confira as vantagens de ter a "), _c('span', [_vm._v("TAG do Caminhoneiro")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-6d0e011e!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/hotsite/components/mainContent/mainContent.vue
// module id = 2162
// module chunks = 1